import React from "react";
import { useState, useEffect } from "react";
import CaregiverMenu from "./CaregiverLayout/CaregiverMenu"
import { Nav, NavLink, NavItem } from "react-bootstrap";
import { TabContent, TabPane } from 'reactstrap'
import CaregiverTopMenu from "./CaregiverLayout/CaregiverTopMenu";
const CaregiverTab = (props) => {
    //CaregiverTopMenuContent
    const [tabs, setTabs] = useState([])
    const [component, setComponent] = useState({})

    const MenuItems = CaregiverMenu();
    const activeTabElement = MenuItems.filter((item) => item.right === true)[0]
    console.log('activeTabElement',MenuItems.filter((item) => item.right === true)[0])
    const [tabList, setTabsList] = useState([])
    const [activeTab, setActiveTab] = useState(61)

    useEffect(() => {
        const activeComponent = MenuItems.filter((tab, key) => {
            return tab.right === true
        })[0]
        console.log('activeComponent',MenuItems.filter((tab, key) => {
            return tab.right === true
        })[0])
        setComponent(activeComponent)
    }, [activeTab])

    const handleActiveTab = (item) => {
        const { key, name, right } = { ...item }
        let dynamicTabs = [...tabList]
        if (tabList.length === 0) {
            const obj = {
                key: activeTabElement.key,
                name: activeTabElement.name,
                right: activeTabElement.right,
            }
            dynamicTabs.push(obj)
        }
        const newTabObject = {
            key: key,
            name: name,
            right: right,
        }
        const isTabExist = dynamicTabs.filter((tab) => {
            return tab.name === name
        })
        if (!(isTabExist && isTabExist.length > 0)) {
            dynamicTabs = [...dynamicTabs, newTabObject]
            setTabsList(dynamicTabs)
        }
        if (activeTab !== key) {
            setActiveTab(key)
        }
    }

    return (
        <>
            <Nav className="navBootstrap nav-tabs" >
                {MenuItems && MenuItems.map((item) => {
                    return (
                        <React.Fragment key={item.key}>
                            <NavItem onClick={() => handleActiveTab(item)}>
                                <NavLink href="#" className={activeTab === item.key ? "active" : ""}></NavLink>
                            </NavItem>
                        </React.Fragment>

                    )
                })}
            </Nav>
            {tabList.length > 0 ? (
                <>
                    <TabContent activeTab={activeTab}>
                        {tabList &&
                            tabList.map((item) => {
                                return (
                                    <React.Fragment key={item.key}>
                                        <TabPane tabId={item.key}>
                                            <div>
                                                <div>
                                                    <CaregiverTopMenu subCategKey={item.key} />
                                                </div>
                                            </div>
                                        </TabPane>
                                    </React.Fragment>
                                )
                            })}
                    </TabContent>
                </>
            ) : (
                    <TabContent activeTab={component.key}>
                        <React.Fragment key={component.key}>
                            <TabPane tabId={component.key}>
                                <CaregiverTopMenu subCategKey={component.key} />
                            </TabPane>
                        </React.Fragment>
                    </TabContent>
            )}
    </>

    )
}
export default CaregiverTab